module.exports = __webpack_public_path__ + "media/icon_transaction/frog-af097a3e.png";